<script>
import { layoutComputed } from "@/state/helpers";
import Vertical from "./vertical";
import Horizontal from "./horizontal";

export default {
  components: {
    Vertical,
    Horizontal,
  },
  data() {
    return {};
  },
  computed: {
    ...layoutComputed,
  },
  methods: {
    changeCycle(cycle) {
      this.$emit("changeCycle", cycle);
    },
    changeCampus(campus) {
      this.$emit("changeCampus", campus);
    },
    changeDU(du) {
      this.$emit("changeDU", du);
    },
    changeDepartment(department) {
      this.$emit("changeDepartment", department);
    },
  },
  mounted() {
    // document.querySelector("html").setAttribute('dir', 'rtl');
  },
};
</script>

<template>
  <div>
    <Vertical v-if="layoutType === 'vertical'" :layout="layoutType">
      <slot />
    </Vertical>

    <Horizontal
      v-if="layoutType === 'horizontal'"
      :layout="layoutType"
      @changeCycle="changeCycle"
      @changeCampus="changeCampus"
      @changeDU="changeDU"
      @changeDepartment="changeDepartment"
    >
      <slot />
    </Horizontal>
  </div>
</template>
